import React, { useEffect, useState } from 'react'

import ButtonComponent from './ButtonComponent'

import 'cropperjs/dist/cropper.css'

interface IUploadMediaButtonData {
    onFileUpload?: (image: string, file: File | undefined) => void // Not used for images and video
    onImageUpload?: (image: string, file: File | undefined) => void
    onVideoUpload?: (video: string, file: File | undefined) => void
    allowImageUpload?: boolean
    allowVideoUpload?: boolean
    allowAdditionalTypes?: string
}

export const UploadMediaButton: React.FC<IUploadMediaButtonData> = (props) => {
  const [fileUrl, setFileUrl] = useState<string | undefined>()
  const [file, setFile] = useState<File | undefined>()
  const [allowImageUpload, setAllowImageUpload] = useState<boolean>(true)
  const [allowVideoUpload, setAllowVideoUpload] = useState<boolean>(true)
  const [allowAdditionalTypes, setAllowAdditionalTypes] = useState<string>('')

  useEffect(() => {
    props.allowImageUpload !== undefined && setAllowImageUpload(props.allowImageUpload)
    props.allowVideoUpload !== undefined && setAllowVideoUpload(props.allowVideoUpload)
    props.allowAdditionalTypes && setAllowAdditionalTypes(props.allowAdditionalTypes)
  }, [props])

  useEffect(() => {
    if (file && fileUrl) {
      file.type.includes('image') && props.onImageUpload && props.onImageUpload(fileUrl, file)
      file.type.includes('video') && props.onVideoUpload && props.onVideoUpload(fileUrl, file)
      props.onFileUpload && props.onFileUpload(fileUrl, file) // Control what Files can be sent here via the allowAditionalTypes property
    }
  }, [fileUrl, file])

  const onChange = (e: any) => {
    e.preventDefault()
    let files
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    setFile(files[0])

    const reader = new FileReader()
    reader.onload = () => {
      setFileUrl(reader.result as any)
    }
    reader.readAsDataURL(files[0])
  }

  const hiddenFileInput = React.useRef<HTMLInputElement>(null)
  const handleClick = () => {
        hiddenFileInput?.current?.click()
  }

  return (
    <>
      <ButtonComponent
        color='primary'
        text='Neue Datei hochladen'
        onClick={handleClick}
      />
      <input
        type='file'
        ref={hiddenFileInput}
        onInput={onChange}
        style={{ display: 'none' }}
        accept={((allowImageUpload && 'image/* ') || '') + ((allowVideoUpload && 'video/* ') || '') + (allowAdditionalTypes)}
      />
    </>
  )
}
export default UploadMediaButton
